import { Modal } from 'antd';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  .ant-modal-body {
    padding: 0;
  }

  .ant-modal-content {
    border-radius: 8px;
    overflow-y: auto;
    overflow-x: hidden;

    background-color: ${(props) => props.theme.colors.whiteSmoke};
  }

  width: 90vw !important;
  max-width: 1052px !important;

  @media ${(props) => props.theme.screen.md} {
    width: 80vw !important;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 30px;

  @media ${(props) => props.theme.screen.md} {
    padding: 40px 50px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
  padding-bottom: 20px;
  border-bottom: 1px solid ${(props) => props.theme.colors.black};
`;

export const LogoWrapper = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  width: 100px;
  height: 100px;
  padding: 10px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  @media ${(props) => props.theme.screen.sm} {
    width: 125px;
    height: 125px;
    padding: 10px;
  }
`;

export const Logo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

export const Title = styled.h2`
  font-family: ${(props) => props.theme.fontFamilies.vollkorn};
  font-weight: ${(props) => props.theme.fontWeights.medium};
  font-size: 24px;
  line-height: 130%;
  margin: 0;
  color: ${(props) => props.theme.colors.black};

  @media ${(props) => props.theme.screen.sm} {
    font-size: 32px;
  }

  @media ${(props) => props.theme.screen.md} {
    font-size: 40px;
  }
`;

export const Subtitle = styled.p`
  font-family: ${(props) => props.theme.fontFamilies.vollkorn};
  font-weight: ${(props) => props.theme.fontWeights.medium};
  font-size: 16px;
  line-height: 130%;
  letter-spacing: 0%;
  margin: 0;
  color: ${(props) => props.theme.colors.black};

  @media ${(props) => props.theme.screen.sm} {
    font-size: 18px;
  }

  @media ${(props) => props.theme.screen.md} {
    font-size: 24px;
  }
`;

export const LetterContent = styled.div`
  padding-top: 20px;
  p {
    font-family: ${(props) => props.theme.fontFamilies.vollkorn};
    font-weight: ${(props) => props.theme.fontWeights.medium};
    font-size: 14px;
    line-height: 150%;
    letter-spacing: 0%;
    margin: 0 0 24px 0;
    color: ${(props) => props.theme.colors.black};

    @media ${(props) => props.theme.screen.sm} {
      font-size: 16px;
    }

    @media ${(props) => props.theme.screen.md} {
      font-size: 24px;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const BottomSection = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 62px;

  @media ${(props) => props.theme.screen.md} {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    padding-bottom: 16px;
  }
`;

export const SignatureSection = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;

  @media ${(props) => props.theme.screen.lg} {
    gap: 48px;
    align-items: flex-start;
  }
`;

export const AuthorImage = styled.img`
  width: 100px;
  height: 120px;
  object-fit: cover;
  border-radius: 4px;
  flex-shrink: 0;

  @media ${(props) => props.theme.screen.lg} {
    width: 130px;
    height: 150px;
  }
`;

export const SignatureText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  margin-top: 16px;
`;

export const SignaturePrefix = styled.p`
  font-family: ${(props) => props.theme.fontFamilies.vollkorn};
  font-weight: ${(props) => props.theme.fontWeights.medium};
  font-style: italic;
  font-size: 24px;
  line-height: 130%;
  letter-spacing: 0%;
  margin: 0;
  color: ${(props) => props.theme.colors.black};

  @media ${(props) => props.theme.screen.lg} {
    font-size: 36px;
  }
`;

export const AuthorName = styled.p`
  font-family: ${(props) => props.theme.fontFamilies.vollkorn};
  font-weight: ${(props) => props.theme.fontWeights.medium};
  font-size: 20px;
  line-height: 130%;
  letter-spacing: 0%;
  margin: 0;
  color: ${(props) => props.theme.colors.black};

  @media ${(props) => props.theme.screen.lg} {
    font-size: 24px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;

  gap: 12px;
  margin-top: 24px;

  @media ${(props) => props.theme.screen.lg} {
    justify-content: center;
    align-items: flex-end;

    gap: 30px;
    padding-bottom: 16px;
  }
`;

export const Button = styled.button`
  color: ${(props) => props.theme.colors.white};
  font-family: ${(props) => props.theme.fontFamilies.vollkorn};
  font-weight: ${(props) => props.theme.fontWeights.semiBold};
  font-style: italic;
  font-size: 12px;
  line-height: 130%;
  letter-spacing: 0%;
  white-space: nowrap;

  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s ease;

  width: 140px;

  &:hover {
    opacity: 0.8;
  }

  @media ${(props) => props.theme.screen.lg} {
    width: 200px;

    font-size: 16px;
    padding: 14px 32px;
  }

  @media ${(props) => props.theme.device.laptopL} {
    width: 240px;
  }
`;

export const ReadAnotherButton = styled(Button)`
  background-color: #cfa55d;
`;

export const VisitOrgButton = styled(Button)`
  background-color: #4e008a;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
